export default "__VITE_ASSET__4ba0d9ca__"